var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "viewer" }, [
    _c(
      "div",
      {
        staticClass: "v-img",
        style: { width: _vm.width + "px", height: _vm.height + "px" }
      },
      [_c("img", { attrs: { src: _vm.src, alt: "" } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }